import {
  Collection,
  Header,
  ListBoxItem as AriaListBoxItem,
  ListBoxItemProps,
  ListBoxSection,
  SectionProps,
  composeRenderProps,
} from "react-aria-components";
import { Check } from "lucide-react";
import { cn } from "@/utils/helpers";

export function KitDropdownItem(props: ListBoxItemProps) {
  const textValue = props.textValue || (typeof props.children === "string" ? props.children : undefined);
  return (
    <AriaListBoxItem
      {...props}
      textValue={textValue}
      className={composeRenderProps(props.className, (cls, { isFocused, isDisabled, isSelected }) =>
        cn(
          // Menu row (library, style B): 36px, radius 10, muted until hovered or
          // picked; the picked row takes the accent tint and a check.
          "co-dropdown-option group flex min-h-9 items-center gap-2.5 rounded-row px-2.5 py-2 text-[13px] font-medium outline-none cursor-default select-none",
          isDisabled ? "text-co-faint" : isSelected || isFocused ? "text-co-text" : "text-co-muted",
          isFocused && !isDisabled && "bg-co-hover",
          isSelected && "bg-co-accent-dim",
          cls,
        ),
      )}
    >
      {composeRenderProps(props.children, (kids, { isSelected, selectionMode }) => (
        <>
          <span className={cn("min-w-0 flex-1", typeof kids === "string" ? "truncate" : "flex items-center gap-2 overflow-hidden")}>{kids}</span>
          {isSelected && selectionMode !== "none" && <Check aria-hidden className="size-3 shrink-0 text-co-accent" />}
        </>
      ))}
    </AriaListBoxItem>
  );
}

export interface KitDropdownSectionProps<T> extends SectionProps<T> {
  title?: string;
  items?: Iterable<T>;
}

export function KitDropdownSection<T extends object>(props: KitDropdownSectionProps<T>) {
  return (
    <ListBoxSection className="first:-mt-1 after:block after:h-1 after:content-[''] last:after:hidden">
      <Header className="truncate px-2.5 pt-2.5 pb-1 text-[11px] font-medium uppercase tracking-[0.12em] text-co-faint">
        {props.title}
      </Header>
      <Collection items={props.items}>{props.children}</Collection>
    </ListBoxSection>
  );
}
